// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"83":"6c1d25a2","401":"86ef35b7","435":"88eb50e5","455":"dcb1cb71","529":"88eb50e5","540":"a476df43","912":"88eb50e5"}[chunkId] + ".chunk.css";
};